import TopicAttachmentsManager, { AttachmentsView } from 'managers/topic/attachments';
import pattern from 'patterns/surveyImages';
import { WCCContentAttachmentsBlock } from '../blocks/attachments/attachments';
import WCCContentContext from '../context';
import WCCContentPatternRule from './pattern';

export default class WCCContentSurveyImagesRule extends WCCContentPatternRule {
    protected pattern = pattern;

    protected process([content, idsStr]: RegExpMatchArray, context: WCCContentContext) {
        const attachmentContentIDs = idsStr.split(';').map(s => s.trim());

        const surveyImagesManager = context.storage.get(TopicAttachmentsManager, { topicId: context.topicId, view: AttachmentsView.surveyImages });
        const surveyImages = surveyImagesManager.pluck(m => m.attachments, []);

        const attachments = surveyImages.filter(a => attachmentContentIDs.includes(a.contentId()));

        return new WCCContentAttachmentsBlock({ content, attachments, columnWidth: 120, rowsCount: 0, expand: false });
    }
}